import { graphQlClient } from '@config/graphqlClient';
import SubcontractorGraphQL from '@graphql/subcontractor.queries';
import {
  getSubcontractorBidsRequest,
  getSubcontractorOverviewRequest,
  getSubcontractorRosterRequest,
  SubcontractorBid,
  SubcontractorOverview,
  SubcontractorRosterEntry,
} from '@models/subcontractor.model';

export const subcontractorOverviewService = {
  async getRoster(): Promise<SubcontractorRosterEntry[]> {
    const data: getSubcontractorRosterRequest = await graphQlClient.request(
      SubcontractorGraphQL.queries.getSubcontractorRoster,
    );
    return data.getSubcontractorRoster || [];
  },

  async getOverview(subOrganizationId: string, projectIds?: string[]): Promise<SubcontractorOverview> {
    const data: getSubcontractorOverviewRequest = await graphQlClient.request(
      SubcontractorGraphQL.queries.getSubcontractorOverview,
      { subOrganizationId, projectIds },
    );
    return data.getSubcontractorOverview;
  },

  async getBids(subOrganizationId: string): Promise<SubcontractorBid[]> {
    const data: getSubcontractorBidsRequest = await graphQlClient.request(
      SubcontractorGraphQL.queries.getSubcontractorBids,
      { subOrganizationId },
    );
    return data.getSubcontractorBids || [];
  },
};

export default subcontractorOverviewService;
